module.exports = __webpack_public_path__ + "static/media/krakow.16b9222b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/krakow.png
// module id = 864
// module chunks = 0